"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnumFromValueType = exports.getEmitterTypeToEnum = exports.getValueTypeFromEmitterType = exports.getEmitterTypeFromValueType = exports.enumToValueType = exports.IRRIGATION_ACTIVITY_FLOW_METER_VALUE_TYPE_PREFIX = exports.IRRIGATION_ACTIVITY_PLANNED_VALUE_TYPE_PREFIX = exports.IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX = exports.IRRIGATION_PLANNED_VOLUME_VALUE_TYPE_PREFIX = exports.IRRIGATION_APPLIED_VOLUME_VALUE_TYPE_PREFIX = exports.IRRIGATION_PRESSURE_VALUE_TYPE_PREFIX = exports.EMITTER_TYPE_VALUE_TYPES = exports.EMITTER_TYPES = void 0;
exports.EMITTER_TYPES = [
    'emitter-buried-drip-1',
    'emitter-buried-drip-2',
    'emitter-drip-1',
    'emitter-drip-2',
    'emitter-microspray',
    'emitter-sprinkler',
    'emitter-flood-furrow',
    'emitter-overhead-cooling-microspray',
    'emitter-overhead-cooling-sprinkler',
    'emitter-other',
    'valve-1',
    'valve-2',
    'valve-3',
    'valve-4',
    'valve-5',
    'valve-6',
    'valve-7',
    'valve-8',
    'valve-9',
    'valve-10',
    'pump',
    'pre-filter',
    'post-filter',
    'system-pressure',
];
exports.EMITTER_TYPE_VALUE_TYPES = [
    'emitterBuriedDrip1',
    'emitterBuriedDrip2',
    'emitterDrip1',
    'emitterDrip2',
    'emitterFloodFurrow',
    'emitterMicrospray',
    'emitterSprinkler',
    'emitterOverheadCoolingMicrospray',
    'emitterOverheadCoolingSprinkler',
    'emitterOther',
    'valve1',
    'valve2',
    'valve3',
    'valve4',
    'valve5',
    'valve6',
    'valve7',
    'valve8',
    'valve9',
    'valve10',
    'pump',
    'preFilter',
    'postFilter',
    'systemPressure',
];
exports.IRRIGATION_PRESSURE_VALUE_TYPE_PREFIX = 'irrigationPressureSemios_';
exports.IRRIGATION_APPLIED_VOLUME_VALUE_TYPE_PREFIX = 'irrigationVolumeDurationSemios_';
exports.IRRIGATION_PLANNED_VOLUME_VALUE_TYPE_PREFIX = 'irrigationPlannedVolumeDurationSemios_';
exports.IRRIGATION_ACTIVITY_APPLIED_VALUE_TYPE_PREFIX = 'irrigationActivityIntervalsSemios_';
exports.IRRIGATION_ACTIVITY_PLANNED_VALUE_TYPE_PREFIX = 'irrigationActivityPlannedIntervalsSemios_';
exports.IRRIGATION_ACTIVITY_FLOW_METER_VALUE_TYPE_PREFIX = 'irrigationFlow';
const valueTypeSuffixToEnum = {
    'emitter-buried-drip-1': 'emitterBuriedDrip1',
    'emitter-buried-drip-2': 'emitterBuriedDrip2',
    'emitter-drip-1': 'emitterDrip1',
    'emitter-drip-2': 'emitterDrip2',
    'emitter-flood-furrow': 'emitterFloodFurrow',
    'emitter-microspray': 'emitterMicrospray',
    'emitter-other': 'emitterOther',
    'emitter-overhead-cooling-microspray': 'emitterOverheadCoolingMicrospray',
    'emitter-overhead-cooling-sprinkler': 'emitterOverheadCoolingSprinkler',
    'emitter-sprinkler': 'emitterSprinkler',
    'valve-1': 'valve1',
    'valve-2': 'valve2',
    'valve-3': 'valve3',
    'valve-4': 'valve4',
    'valve-5': 'valve5',
    'valve-6': 'valve6',
    'valve-7': 'valve7',
    'valve-8': 'valve8',
    'valve-9': 'valve9',
    'valve-10': 'valve10',
    'pump': 'pump',
    'pre-filter': 'preFilter',
    'post-filter': 'postFilter',
    'system-pressure': 'systemPressure',
};
exports.enumToValueType = {
    emitterBuriedDrip1: 'emitter-buried-drip-1',
    emitterBuriedDrip2: 'emitter-buried-drip-2',
    emitterDrip1: 'emitter-drip-1',
    emitterDrip2: 'emitter-drip-2',
    emitterFloodFurrow: 'emitter-flood-furrow',
    emitterMicrospray: 'emitter-microspray',
    emitterOther: 'emitter-other',
    emitterOverheadCoolingMicrospray: 'emitter-overhead-cooling-microspray',
    emitterOverheadCoolingSprinkler: 'emitter-overhead-cooling-sprinkler',
    emitterSprinkler: 'emitter-sprinkler',
    valve1: 'valve-1',
    valve2: 'valve-2',
    valve3: 'valve-3',
    valve4: 'valve-4',
    valve5: 'valve-5',
    valve6: 'valve-6',
    valve7: 'valve-7',
    valve8: 'valve-8',
    valve9: 'valve-9',
    valve10: 'valve-10',
    pump: 'pump',
    preFilter: 'pre-filter',
    postFilter: 'post-filter',
    systemPressure: 'system-pressure',
};
const getEmitterTypeFromValueType = (valueType) => {
    const kebabCasedEmitter = valueType
        ?.match(/(?:_emitte|_pum)([^_]+)_/)?.[0]
        ?.replace(/_/g, '')
        ?.replace(/([a-z])([A-Z0-9])/g, '$1-$2')
        ?.toLowerCase();
    // if (kebabCasedEmitter && kebabCasedEmitter in valueTypeSuffixToEnum)
    return kebabCasedEmitter;
    // return null
};
exports.getEmitterTypeFromValueType = getEmitterTypeFromValueType;
const getValueTypeFromEmitterType = (valueTypePrefix, emitterType) => {
    const suffix = valueTypeSuffixToEnum[emitterType];
    return valueTypePrefix + suffix;
};
exports.getValueTypeFromEmitterType = getValueTypeFromEmitterType;
const getEmitterTypeToEnum = (emitterType) => valueTypeSuffixToEnum[emitterType];
exports.getEmitterTypeToEnum = getEmitterTypeToEnum;
const getEnumFromValueType = (valueType) => {
    const parts = valueType.split('_');
    if (parts.length !== 2) {
        return null;
    }
    const emitter = parts[1];
    return emitter in exports.enumToValueType ? exports.enumToValueType[emitter] : null;
};
exports.getEnumFromValueType = getEnumFromValueType;
//# sourceMappingURL=emitterTypeToValueTypeMapper.js.map